import script from "./VideoSupportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoSupportPage.vue?vue&type=script&setup=true&lang=js"

import "./VideoSupportPage.vue?vue&type=style&index=0&id=4d271271&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d271271"]])

export default __exports__